import { resolveApiUrl } from "../../api";
import type { RecordItem } from "./useRecordHistory";

const normalized = (text: string) => text.trim().replace(/\s+/g, " ");

/** Diary titles are excerpts generated by the API, not separate user titles. */
export function recordText(record: RecordItem) {
  const content = record.content || "";
  const title = (record.title || "").trim();
  const duplicate = normalized(title) === normalized(content) ||
    content.split(/\r?\n/).some(line => normalized(line) === normalized(title));
  return { title: record.kind === "note" || duplicate ? "" : title, content };
}

export function recordImages(record: RecordItem): string[] {
  if (!Array.isArray(record.data?.images)) return [];
  return record.data.images
    .filter((image: { url?: unknown }) => typeof image?.url === "string" && image.url.trim())
    .map((image: { url: string }) => resolveApiUrl(image.url));
}

const dimensionLabels: Record<string, string> = {
  body: "身 · 身体", heart: "心 · 内心", intellect: "智 · 学习",
  craft: "技 · 技能", bond: "缘 · 人际", purpose: "志 · 方向",
};
export function recordDimensions(record: RecordItem) {
  return Array.from(new Set(record.dimensions || []))
    .filter(key => dimensionLabels[key])
    .map(key => ({ key, label: dimensionLabels[key] }));
}

export function recordTimestamp(record: RecordItem) {
  if (!record.time) return `${record.day.replace(/-/g, "/")} · 全天记录`;
  const instant = new Date(record.time);
  if (!Number.isFinite(instant.getTime())) return record.day.replace(/-/g, "/");
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: "Asia/Shanghai", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hour12: false,
  }).format(instant);
}
